import { mutate } from "swr";

import * as api from "../api";

export const register = async (values: {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  yearOfBirth?: number;
  gender?: string;
  profilePicture?: File;
}) => {
  const profile = await api.register(values);
  mutate("/profiles/me", profile);
  return profile;
};

export const login = async (values: { email: string; password: string }) => {
  await api.login(values);
  mutate("/profiles/me");
};

export const logout = (nextUrl?: string) => {
  localStorage.clear();
  sessionStorage.clear();
  api.saveClientCredentials();

  // Logging out without reload is tricky - we need to clear the whole SWR cache,
  // and lots of the login checks run on mount. For now, just reload.
  if (nextUrl) {
    window.location.href = nextUrl;
  } else {
    window.location.reload();
  }
};

export const getIsLoggedIn = () =>
  !!(
    sessionStorage.getItem("accessToken") &&
    sessionStorage.getItem("refreshToken")
  );
